import {registerApplication, start} from 'single-spa';
import {constructApplications, constructLayoutEngine, constructRoutes} from 'single-spa-layout';
import microfrontendLayout from './microfrontend-layout.html';

const applicationValidateLoad = (name) => {
  return sessionStorage.getItem('token') && sessionStorage.getItem('tokenAD');
};

const excludedApps = [
  '@sodimac/sod-mf-react-login',
  '@sodimac/sod-mf-angular-landing',
  '@sodimac/sod-mf-angular-landing-qa',
  '@sodimac/sod-mf-gestion-inventario',
  '@sodimac/sod-mf-gestion-bodegas',
  '@sodimac/sod-mf-registro',
];

const routes = constructRoutes(microfrontendLayout);
const applications = constructApplications({
  routes,
  loadApp({name}) {
    console.log('PROD v2.0.0');
    console.log(name, ' - ', window.location.href);
    if (excludedApps.includes(name) || applicationValidateLoad(name)) {
      return System.import(name);
    } else {
      window.location.href = '/landing';
      throw Error('application disabled');
    }
  }
});
const layoutEngine = constructLayoutEngine({routes, applications});

applications.forEach(registerApplication);
layoutEngine.activate();
start();
